export default "__VITE_ASSET__CQEPjiae__"